import { isEmpty, find, isInteger } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import Avatar, { IAvatar } from '../../Clients/Avatar';
import Count from '../../Common/Count';
import Name from '../../Clients/Name';
import Selector from '../../Common/Selector';
import { pluralize } from '@utils/strings';

const { CLASS_NAME_PREFIX } = Selector;

const PLACEHOLDER = 'Выбрать ответственного';

const StyledAvatar = styled(Avatar)``;

const StyledName = styled(Name)`
  font-size: 14px;
  font-weight: 300;
`;

const StyledCount = styled(Count)`
  margin-left: auto;
`;

const StyledMangerBase = styled.div`
  align-items: center;
  display: flex;
`;

const StyledOption = styled(StyledMangerBase)`
  align-items: center;
  display: flex;

  ${StyledAvatar} {
    height: 26px;
    width: 26px;
  }

  ${StyledName} {
    color: #4d4d4d;
    margin-left: 10px;
  }
`;

const StyledValue = styled(StyledMangerBase)`
  ${StyledAvatar} {
    height: 18px;
    width: 18px;
  }

  ${StyledName} {
    margin-left: 6px;
  }
`;

const StyledCompactValue = styled.div`
  padding-left: 10px;
  position: absolute;
  font-size: 14px;
`;

const StyledSelector = styled(Selector)`
  border: 1px solid #e6e9ee;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 3px;

  .${CLASS_NAME_PREFIX}__multi-value {
    background: #f5f3f2;
    border: none;
  }

  .${CLASS_NAME_PREFIX}__multi-value__label {
    padding-left: 4px !important;
    color: #4d4d4d;
  }

  .${CLASS_NAME_PREFIX}__placeholder {
    color: #919499;
  }
`;

export type ManagerType = {
  avatarUrl: IAvatar['url'];
  email: string;
  id: string;
  name: string;
  phone: string | null;
  title: string;
  value: string;
};

export interface TicketFilterByManagerProps {
  className?: string;
  managers?: ManagerType[] | null;
  name: string;
  value: string[] | null;
  isCompact: boolean;
  components: any;
  onChange: (event: CustomEvent) => void;
}

class TicketFilterByManager extends React.PureComponent<TicketFilterByManagerProps> {
  el: any = null;

  static defaultProps = {
    className: '',
    managers: null,
    name: '',
    value: null,
    isCompact: false,
    components: {},
  };

  static getMultiValueLabel(prop) {
    const { data, innerProps } = prop;
    const { avatarUrl, name } = data;

    return (
      <StyledValue {...innerProps}>
        <StyledAvatar name={name} url={avatarUrl} />
        <StyledName name={name} />
      </StyledValue>
    );
  }

  static getCompactMultiValue({ index, selectProps }) {
    const { value, menuIsOpen } = selectProps;
    if (index > 0 || menuIsOpen) return null;

    return (
      <StyledCompactValue>
        {`${pluralize(value.length, ['Выбран', 'Выбрано', 'Выбраны'])} ${
          value.length
        } ${pluralize(value.length, ['менеджер', 'менеджера', 'менеджеров'])}`}
      </StyledCompactValue>
    );
  }

  static customFilter({ data }, searchText) {
    const { name } = data;

    const formattedName = (name && name.toLowerCase()) || '';
    const formattedQuery = searchText && searchText.toLowerCase();

    const isMatched = formattedName.includes(formattedQuery);

    return isMatched;
  }

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleRef = this.handleRef.bind(this);
  }

  handleChange(value) {
    const { name, onChange } = this.props;

    const formatedValue = Array.isArray(value) ? value.map(v => v.value) : null;
    this.el.name = name;
    this.el.value = formatedValue;

    const event = new CustomEvent('change', {
      bubbles: true,
    });

    this.el.dispatchEvent(event);
    onChange(event);
  }

  handleRef(ref) {
    this.el = ReactDOM.findDOMNode(ref);
  }

  render() {
    const { managers, value, isCompact, components, ...props } = this.props;

    if (isEmpty(managers)) {
      return null;
    }

    let formatedValue: (ManagerType | undefined)[] | null = null;
    if (Array.isArray(value)) {
      formatedValue = value.map(v => find(managers, { value: v }));
    }

    return (
      <StyledSelector
        {...props}
        components={{
          ...components,
          ...(isCompact && {
            MultiValue: TicketFilterByManager.getCompactMultiValue,
          }),
          MultiValueLabel: TicketFilterByManager.getMultiValueLabel,
        }}
        isMulti
        isSearchable
        filterOption={TicketFilterByManager.customFilter}
        onChange={this.handleChange}
        options={managers}
        placeholder={PLACEHOLDER}
        ref={this.handleRef}
        value={formatedValue}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
      >
        {({ data }) => {
          const { avatarUrl, name, unreadAmount } = data;
          const isValidCount = isInteger(unreadAmount) && unreadAmount > 0;

          return (
            <StyledOption>
              <StyledAvatar name={name} url={avatarUrl} />
              {name && <StyledName name={name} />}
              {isValidCount && <StyledCount value={unreadAmount} />}
            </StyledOption>
          );
        }}
      </StyledSelector>
    );
  }
}

export default TicketFilterByManager;
